import type { Action, TimerState } from '@/hooks/useTimer';
import DoneButton from './Buttons/DoneButton';
import NextButton from './Buttons/NextButton';
import PauseButton from './Buttons/PauseButton';
import PreviousButton from './Buttons/PreviousButton';
import ResetButton from './Buttons/ResetButton';
import ResumeButton from './Buttons/ResumeButton';
import StartButton from './Buttons/StartButton';

type ControlsProps = {
  dispatch: (action: Action) => void;
  state: TimerState;
};

function Controls({ dispatch, state }: ControlsProps) {
  const { initial, done, isRunning } = state;

  if (initial) {
    return <StartButton onClick={() => dispatch('START')} />;
  }

  if (done) {
    return <DoneButton onClick={() => dispatch('RESET')} />;
  }

  return (
    <>
      <div className="flex flex-row justify-between">
        <PreviousButton onClick={() => dispatch('PREVIOUS')} />
        {isRunning
          ? <PauseButton onClick={() => dispatch('PAUSE')} />
          : <ResumeButton onClick={() => dispatch('RESUME')} />}
        <NextButton onClick={() => dispatch('NEXT')} />
      </div>
      {!isRunning && <ResetButton onClick={() => dispatch('RESET')} />}
    </>
  );
}

export default Controls;
